import '@hotwired/turbo-rails'

import * as bootstrap from 'sard_core/vendor/assets/bootstrap/javascripts/bootstrap.js'
import { application } from './controllers/application' // Stimulus application instance

import 'sard_core/app/javascript/shared/core'

import FlashController from 'sard_core/app/javascript/controllers/flash_controller'
application.register('flash', FlashController)

import OtpDigitFieldController from 'sard_core/app/javascript/controllers/otp_digit_field_controller'
application.register('otp-digit-field', OtpDigitFieldController)

import './controllers' // local ones
